import { Injectable } from "@angular/core";
@Injectable()
export class NotificationModel{
    id: Number;
    message: String;
    tagId: String;
    tagName: String;
    status: Number;
    scheduled: Date;
    pushNotification: boolean;
    emailNotification: boolean;
    sms: boolean;
    voiceCall: boolean;
    createdBy: Number;
}